import Siema from 'siema';

// initializing Slider

const siemaDesktop = new Siema({
    selector: '.c-Carousel-slide__desktop',
    duration: 200,
    easing: 'ease-out',
    perPage: {
        768: 4
    },
    startIndex: 0,
    draggable: true,
    multipleDrag: false,
    threshold: 20,
    loop: true,
    rtl: false,
    onInit: () => {},
    onChange: () => {},
});

const prev = document.querySelector('.c-Carousel__toggle-prev');
const next = document.querySelector('.c-Carousel__toggle-next');

prev.addEventListener('click', () => siemaDesktop.prev(4));
next.addEventListener('click', () => siemaDesktop.next(4));

document.getElementById('homeBanner').style.visibility = 'visible';
document.getElementById('homeBanner').style.maxHeight = '';

const siemaMobile = new Siema({
    selector: '.c-Carousel-slide__mobile',
    duration: 200,
    easing: 'ease-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    multipleDrag: false,
    threshold: 20,
    loop: true,
    rtl: false,
    onInit: () => {},
    onChange: () => {},
});

prev.addEventListener('click', () => siemaMobile.prev());
next.addEventListener('click', () => siemaMobile.next());